import { render, staticRenderFns } from "./destinationMapPopup.vue?vue&type=template&id=471637d0&scoped=true&"
import script from "./destinationMapPopup.vue?vue&type=script&lang=js&"
export * from "./destinationMapPopup.vue?vue&type=script&lang=js&"
import style0 from "./destinationMapPopup.vue?vue&type=style&index=0&id=471637d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471637d0",
  null
  
)

export default component.exports